/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import {
  ORDER_REQUEST_STATUS,
  ORDER_REQUEST_TYPES
} from '@/modules/tracking/constants';

/**
 * Component.
 */
@Component({ name: 'client-request-notification' })
export default class extends Vue {
  /**
   * Property `notification`.
   */
  isModalVisible = false;

  /**
   * Property `notification`.
   */
  @Prop({
    default: null,
    type: Object
  })
  notification: {
    status: string;

    type: string;
  };

  /**
   * Property `visible`.
   */
  @Prop({ default: false })
  visible: boolean;

  /**
   * Getter `message`.
   */
  get title() {
    const { status } = this.notification || {};

    let title = null;

    switch (status) {
      case ORDER_REQUEST_STATUS.TREATED:
        title = this.i18n('TRACKING.MESSAGES.REQUEST_APROVED');
        break;

      case ORDER_REQUEST_STATUS.REJECTED:
        title = this.i18n('TRACKING.MESSAGES.REQUEST_REJECTED');
        break;
    }

    return `${title}`;
  }

  /**
   * Getter `message`.
   */
  get message() {
    const { status, type } = this.notification || {};
    const requestType = type
      ? this.i18n(`TRACKING.MESSAGES.REQUEST_${type}`).toLocaleLowerCase()
      : '';

    let message = null;
    let statusSuffix = null;

    switch (status) {
      case ORDER_REQUEST_STATUS.TREATED:
        statusSuffix = 'APPROVED';
        break;

      case ORDER_REQUEST_STATUS.REJECTED:
        statusSuffix = 'REJECTED';
        break;
    }

    if (
      type === ORDER_REQUEST_TYPES.CHANGE_DATE ||
      type === ORDER_REQUEST_TYPES.CHANGE_ADDRESS ||
      type === ORDER_REQUEST_TYPES.CHANGE_DATE_AND_ADDRESS
    ) {
      message = this.i18n(
        `TRACKING.SENTENCES.REQUEST_CHANGE_${statusSuffix}`,
        false,
        'upperFirst',
        { type: requestType }
      );
    }

    if (
      type === ORDER_REQUEST_TYPES.CONTACT ||
      type === ORDER_REQUEST_TYPES.MESSAGE
    ) {
      message = this.i18n(
        `TRACKING.SENTENCES.REQUEST_CONTACT_${statusSuffix}`,
        false,
        'upperFirst',
        { type: requestType }
      );
    }

    return message;
  }

  /**
   * Handle dialog input.
   */
  handleDialogInput(value) {
    if (!value) {
      this.$emit('close');
    }
  }

  /**
   * Handle visible change.
   */
  @Watch('visible')
  handleVisibleChange(value) {
    this.isModalVisible = value;
  }
}
